import React from "react";
import "./Whytaxwithus.css";
import { FaUsers, FaShieldAlt, FaLightbulb, FaHeadset } from "react-icons/fa";

const Whytaxwithus = () => {

const features = [
  {
    icon: <FaUsers className="whytaxwithus-feature-icon" />,
    title: "Personalized Client Care",
    description:
      "We treat every client like family, tailoring tax solutions that respect your unique goals and circumstances.",
  },
  {
    icon: <FaShieldAlt className="whytaxwithus-feature-icon" />, // CHANGED HERE
    title: "Ethics at the Core",
    description:
      "Our approach is rooted in honesty, fairness, and compliance — giving you peace of mind in every decision.",
  },
  {
    icon: <FaLightbulb className="whytaxwithus-feature-icon" />,
    title: "Forward-Thinking Strategies",
    description:
      "We anticipate tax trends and craft innovative approaches, ensuring you’re always ahead, not just compliant.",
  },
  {
    icon: <FaHeadset className="whytaxwithus-feature-icon" />,
    title: "Always Accessible",
    description:
      "Our team is just a call away, ready to answer your questions and provide reliable guidance whenever you need it.",
  },
];


  return (
    <div className="whytaxwithus-section">
      <div className="whytaxwithus-why-section">
        <h1 className="whytaxwithus-whysu">
          Why Litax Works Best for You
        </h1>
        <p
          className="whytaxwithus-para-text-o"
        >
          Partnering with us means choosing a dedicated team that values
          relationships as much as results. We simplify complexities, bring
          clarity to your finances, and ensure your growth journey feels
          effortless.
        </p>
      </div>

      <div className="whytaxwithus-features-section">
        {features.map((feature, index) => (
          <div
            key={index}
            className="whytaxwithus-feature-card"
          >
            {feature.icon}
            <h2>{feature.title}</h2>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Whytaxwithus;
